import { useState } from 'react';
import styled from 'styled-components';
import { MozartModal, MozartButton } from '@pgforsta/mozart_ui/lib/v4';
import ModalWrapper from '../styled/ModalWrapper';
import ButtonGroup from '../styled/ButtonGroup';
import { verify } from '../../api/services/entities';
import useAsync from '../../hooks/async';

const ConfirmationQuestion = styled.p`
  margin-bottom: 15px;
`;

const Status = styled.p`
  text-align: center;
`;

const VerifyEntityModal = ({ show, entityId, onClose }) => {
  const query = useAsync();
  const [confirmation, setConfirmation] = useState(false);

  const handleConfirmation = () => {
    setConfirmation(true);
    query.run(verify(entityId));
  };

  const renderModalContents = () => {
    if (!confirmation) {
      return (
        <>
          <ConfirmationQuestion>{`Do you want to verify the entity ${entityId}?`}</ConfirmationQuestion>
          <ButtonGroup>
            <MozartButton outline onClick={() => onClose(confirmation)}>
              No
            </MozartButton>
            <MozartButton onClick={handleConfirmation}>Yes</MozartButton>
          </ButtonGroup>
        </>
      );
    }

    if (query.isIdle || query.isPending) {
      return <Status>Loading...</Status>;
    }

    if (query.isRejected) {
      return <Status>There was an error verifying the entity.</Status>;
    }

    return <Status>The entity has been verified.</Status>;
  };

  return (
    <ModalWrapper>
      <MozartModal
        show={show}
        onClose={() => onClose(confirmation)}
        title="Verify Entity"
        size="medium"
      >
        {renderModalContents()}
      </MozartModal>
    </ModalWrapper>
  );
};

export default VerifyEntityModal;
